import styled from 'styled-components'

import theme, { breakpoint } from 'style/theme'

export default styled.div`
  .swiper {
    padding-bottom: 20px;
    .swiper-pagination-bullets {
      bottom: 0;
      .swiper-pagination-bullet {
        width: 14px;
        height: 14px;
        background-color: ${theme.lightGray};
      }
      .swiper-pagination-bullet-active {
        background-color: ${theme.red};
      }
    }
  }

  .usp-block {
    .left-block {
      .title-block {
        h2 {
          font-size: 36px;
        }
        h3 {
          color: ${theme.primaryGray};
          margin-bottom: 20px;
        }

        .title {
          margin-bottom: 10px;
        }

        .description-block {
          flex: 1;
          h2 {
            font-size: 32px;
          }
          p,
          li {
            font-size: 22px;
            line-height: 1.4;
            margin-bottom: 0;
          }
          a {
            font-size: 32px;
            color: ${theme.red};
            pointer-events: none;
            font-family: 'Kanit-SemiBold';
          }
          strong {
            font-family: 'Kanit-SemiBold';
          }
        }

        .box-container-mobile {
          display: none;
        }
      }
    }

    .right-block {
      margin-right: 40px;
      .box-container-desktop {
        display: block;
        margin: 0 -10px;
        position: relative;
        width: 100%;
        aspect-ratio: 509 / 342;
        height: auto;
        margin-bottom: 40px;
        .box {
          position: absolute;
          background-color: #f8f9fa;
          border-radius: 40px;
          top: -5px;
          left: 20px;
          width: 100%;
          height: auto;
          aspect-ratio: 509 / 342;
        }
        .box2 {
          position: absolute;
          background-color: #e9ecef;
          border-radius: 40px;
          top: 38px;
          left: 0;
          width: 100%;
          height: auto;
          aspect-ratio: 509 / 342;
        }
        .image-block {
          position: absolute;
          top: 10px;
          left: 30px;
          width: 100%;
          border-radius: 40px;
          height: auto;
          aspect-ratio: 509 / 342;
          opacity: 1;

          img {
            width: 100%;
            border-radius: 30px;
            object-fit: cover;
            height: auto;
            aspect-ratio: 509 / 342;
          }
        }
      }
    }
  }

  @media (max-width: ${breakpoint.lg}) {
    .usp-block {
      .left-block .title-block {
        /* height: 360px; */
        .description-block {
          margin-bottom: 60px;
        }
        .box-container-mobile {
          display: block;
          margin: 0 10px;
          position: relative;
          width: 100%;
          aspect-ratio: 509 / 342;
          height: auto;
          margin-bottom: 40px;
          .box {
            position: absolute;
            background-color: #f8f9fa;
            border-radius: 40px;
            top: 0px;
            left: 20px;
            width: 90%;
            aspect-ratio: 509 / 342;
            height: auto;
          }
          .box2 {
            position: absolute;
            background-color: #e9ecef;
            border-radius: 40px;
            top: 48px;
            left: 0;
            width: 90%;
            aspect-ratio: 509 / 342;
            height: auto;
          }
          .image-block {
            position: relative;
            top: 18px;
            left: 30px;
            img {
              width: 90%;
              border-radius: 30px;
              object-fit: cover;
              height: auto;
              aspect-ratio: 509 / 342;
            }
          }
        }
      }
      .right-block .box-container-desktop {
        display: none;
      }
    }
  }

  @media (max-width: ${breakpoint.sm}) {
    .swiper {
      .swiper-pagination-bullets {
        margin: 0 6px;
        .swiper-pagination-bullet {
          width: 9px;
          height: 9px;
          background-color: ${theme.lightGray};
        }
        .swiper-pagination-bullet-active {
          background-color: ${theme.red};
        }
      }
    }

    .swiper-slide {
      height: 100%;
    }

    .usp-block {
      .left-block {
        .title-block {
          h2 {
            font-size: 26px;
          }
          h3 {
            height: auto;
            font-size: 20px;
            margin-bottom: 10px;
          }
          .description-block {
            margin-bottom: 30px;
            p h2 {
              font-size: 24px;
            }
            p,
            li,
            a {
              font-size: 20px;
            }
          }
          .box-container-mobile {
            margin-top: 10px;
            aspect-ratio: 283 / 196;
            .box {
              display: none;
            }
            .box2 {
              top: 30px;
              left: 0;
              aspect-ratio: 283 / 196;
            }
            .image-block {
              left: 12px;
              img {
                aspect-ratio: 283 / 196;
              }
            }
          }
        }
      }
    }
  }
`
